// extracted by mini-css-extract-plugin
module.exports = {"jcPrimary":"#41c8c3","jcGrey900":"#161f32","content":"GoogleSignIn__content","button":"GoogleSignIn__button","icon":"GoogleSignIn__icon"};